import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import MuiPhoneNumber from 'material-ui-phone-number';
import Divider from '@mui/material/Divider';

const styles = (theme:Theme):any => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    //width: 200,
  },
  hide:{
    display:'none',
  },
});

class FPhoneField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      value: props.value||''
    };
  }

  handleChange = (value:any,extra: any, other: any) => {
    //console.log('phone data ',value,extra,other);
    const {onChange} = this.props;
    //let value = event.target.value;
    this.setState({value});
    //if(typeof onChange === 'function') console.log('final onChange is a function',value);
    //if(typeof onChange === 'function')
    if(typeof onChange === 'function') onChange(value);
  };

  render() {
    const {id,label,required,options,divider,classes } = this.props;
    const {value} = this.state;
    return (
      // <div className={classes.root}>
      <React.Fragment>
        <MuiPhoneNumber
          label={label}
          id={id}
          name={id}
          type={'text'}
          required={required}
          margin='dense'
          fullWidth={true}
          className={classes.textField}
          onChange={this.handleChange}
          value={value}
          {...options}
        />
        {divider && <Divider />}
      </React.Fragment>
      //{/* </div> */}
    );
  }
}

FPhoneField.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(FPhoneField);
